import axios from '@/libs/api.request'
//订单列表
export const apiFactoryOrderList= data => {
    return axios.request({
      url: '/factoryorder/list',
      method: 'post',
      data
    })
  }
//订单详情
export const apiFactoryOrderInfo= data => {
    return axios.request({
      url: `/factoryorder/info`,
      method: 'post',
      data
    })
  }
//发货
export const apiFactoryOrderSendOut= data => {
    return axios.request({
      url: '/factoryorder/send-out',
      method: 'post',
      data
    })
  }

  //快递配送信息
export const apiDeliveryInfo=data => {
  return axios.request({
    url: '/express/delivery-info',
    method: 'post',
    data
  })
}
